import { React, useEffect, useState } from "react";
import TextTransition, { presets } from "react-text-transition";
import WaterWave from "react-water-wave";

const Hero = ({ data }) => {
  const { bgImg, title } = data;

  const [index, setIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);
  return (
    <>
      <WaterWave
        id="home"
        className="st-hero-wrap st-gray-bg st-dynamic-bg overflow-hidden st-fixed-bg st-ripple-version"
        imageUrl={bgImg}
      >
        {(methods) => (
          <div className="st-hero st-style1">
            <div className="container">
              <div className="st-hero-text">
                <div className="st-height-b115 st-height-lg-b80" />
                <h1 className="st-hero-title cd-headline slide">
                  Access Comprehensive <br />
                  Support for
                  <span className="cd-words-wrapper">
                    <TextTransition springConfig={presets.wobbly}>
                      <span className="st-transition-title">
                        {title[index % title.length]}
                      </span>
                    </TextTransition>
                  </span>
                </h1>
              </div>
            </div>
          </div>
        )}
      </WaterWave>
    </>
  );
};

export default Hero;
